import { BehaviorSubject } from 'rxjs';

export default class DialogRepository {
  dialogDetails$ = new BehaviorSubject(null);
  reopenPreviousDialog$ = new BehaviorSubject(false);
  previousDetails$ = new BehaviorSubject({});

  loadDialog(component, props = {}, open = true, closeBtn = false) {
    const details = {
      closeBtn,
      closed: false,
      component,
      open,
      props,
    };

    this.dialogDetails$.next(details);
  }

  async toggleDialog(open) {
    const details = this.dialogDetails$.getValue();
    if (details && !details.closed) {
      this.dialogDetails$.next({ ...details, closed: true, open });
      if (!open && details.props?.onClose) {
        details.props.onClose();

        const { style } = window.document.body;
        if (style.overflow === 'hidden') {
          await new Promise((resolve) => setTimeout(resolve, 500));
          style.overflow = '';
        }
      }
    }
  }
}
